// app/frontend/src/components/UploadComponent.js
import React, { useState } from 'react';
import axiosInstance from './utils/axiosinstance';

import Button from './shared/Button';
import CrossButton from './shared/CrossButton'
import ErrorDisplay from './shared/ErrorDisplay';

function UploadComponent({ mediaType, setSourceMedia, uploadText, setUploadVisible }) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState('');
    const [localVideoDuration, setLocalVideoDuration] = useState(0);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setSelectedFile(file);

        // If video, measure local duration
        if (mediaType === 'video' && file) {
            const tempVideo = document.createElement('video');
            tempVideo.src = URL.createObjectURL(file);
            tempVideo.onloadedmetadata = () => {
                console.log("Local video duration:", tempVideo.duration);
                setLocalVideoDuration(tempVideo.duration);
            };
        }
    };

    const handleUpload = async () => {
        if (!selectedFile) return;

        const formData = new FormData();
        formData.append('media', selectedFile);

        try {
            setUploading(true);
            const response = await axiosInstance.post("/api/upload_media/", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            console.log('Upload response:', response.data);
            
            let media = response.data.media || {};
            // attach localDuration if it’s a video
            if (mediaType === 'video' && localVideoDuration > 0) {
                media.localDuration = localVideoDuration;
            }
            setSourceMedia(media);
            setUploadVisible(false);
            // if (onUploadSuccess) {
            //     onUploadSuccess(response.data);
            // }
        } catch (error) {
            console.error('Upload error:', error.response.data.error);
            setError(error.response.data.error)
        } finally {
            setUploading(false);
        }
    };


    return (
        <>
            <CrossButton
                onClick={() => setUploadVisible(false)}
            />
            <div className="relative">


                <h2 className="flex justify-center text-xl font-semibold text-white mb-4">
                    {uploadText}
                </h2>

                <div className="flex justify-center items-center w-full my-4">
                    <div>
                        <input
                            type="file"
                            accept={mediaType === 'video' ? 'video/*' : 'image/*'}
                            onChange={handleFileChange}
                            className="w-full text-white mb-2"
                        />
                        {selectedFile && (
                            <Button
                                onClick={handleUpload}
                                loading={uploading}
                                disabled={!selectedFile}
                            >
                                Upload {mediaType === 'video' ? 'Video' : 'Image'}
                            </Button>
                        )}
                        <ErrorDisplay
                            errorMessage={error}
                            onClose={() => setError('')}
                        />
                    </div>
                </div>
            </div>
        </>

    );
}

export default UploadComponent;
